export function formatMoney(number, decPlaces, decSep, thouSep) {
    return new Intl.NumberFormat("en-US", { maximumSignificantDigits: 3 }).format(
        number,
    );
}